import { render, staticRenderFns } from "./OrganizationPackage.vue?vue&type=template&id=2335a954&scoped=true"
import script from "./OrganizationPackage.vue?vue&type=script&lang=js"
export * from "./OrganizationPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335a954",
  null
  
)

export default component.exports